import React, { useState, useContext } from 'react';
import Text from '@tds/core-text';

import {
  TopbarWrapper,
  LeftMenu,
  RightMenu,
  Box,
  Button,
  HomeLink
} from './css';
import Menu from './menu';
import request, { USER_RIGHTS } from '../utils/request';
import ModalCustom from './shared/modal';
import UserDetails from './user/userDetails';
import { TranslationsContext } from '../../context/translations';
import { setLocale, getLocale } from '../utils';
import { LANG_ENGLISH, LANG_FRENCH } from '../utils/constant';

const modalCustomStyles = `
  max-height: 60%;
`;

const Topbar = () => {
  const [isUserInfo, setIsUserInfo] = useState(false);
  const staticLabels = useContext(TranslationsContext);
  const {
    USERS: {
      USER_AUTHENTICATION: {
        HEADER: { FRENCH }
      }
    },
    general: { projectName, userProfile, logout }
  } = staticLabels;
  const { getProfile, getToken } = request;
  const token = getToken();
  const profile = getProfile();
  const userName = profile && `${profile.first_name} ${profile.last_name}`;
  const userRights = profile && USER_RIGHTS[profile.role.name];

  const onClickLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const onChangeLocale = () => {
    setLocale(getLocale() === LANG_FRENCH ? LANG_ENGLISH : LANG_FRENCH);
    window.location.reload(false);
  };

  const showUserInfo = val => {
    document.body.style.overflow = val ? 'hidden' : 'visible';
    setIsUserInfo(val);
  };

  return (
    <TopbarWrapper inline between={2}>
      <LeftMenu width={70} mdWidth={100}>
        <Box width={40} mdWidth={100}>
          <HomeLink
            to="/"
            invert
            style={{ textDecoration: 'none', opacity: '1' }}
          >
            <Text invert size="large" bold>
              {projectName}
            </Text>
          </HomeLink>
        </Box>
        <Box width={60} mdWidth={100}>
          {token && userRights ? <Menu userRights={userRights} /> : <></>}
        </Box>
      </LeftMenu>
      {token && userName && (
        <RightMenu width={30} inline between={3}>
          <Button onClick={() => showUserInfo(true)}>{userName}</Button>
          <Button onClick={onClickLogout}>{logout}</Button>
        </RightMenu>
      )}
      <Button onClick={onChangeLocale}>{FRENCH}</Button>
      {profile && (
        <ModalCustom
          open={isUserInfo}
          setOpen={() => showUserInfo(false)}
          header={userProfile}
          customStyles={modalCustomStyles}
        >
          <UserDetails profile={profile} labels={staticLabels} />
        </ModalCustom>
      )}
    </TopbarWrapper>
  );
};

export default Topbar;
